import React, { Suspense, lazy } from "react";
import { Switch, BrowserRouter, Route } from "react-router-dom";
import { useAuthContext } from "contexts/AuthContext.js";
import ServiceWorkerWrapper from "utils/checkUpdatesSW"
import HeaderBar from "shared-components/Header"
import initFontAwesome from "config/initFontAwesome";
initFontAwesome();

const LandingPage = lazy(() => import("./pages/Landing"))
const ErrorPage = lazy(() => import("./pages/Error"))
const DashboardPage = lazy(() => import("./pages/Dashboard"))
const ContactlessPage = lazy(() => import("./pages/Contactless"))
const ImporterQRLoopPage = lazy(() => import("./pages/ImporterQR"))
const SurveyPage = lazy(() => import("./pages/Survey"))
const TrackingHistoricPage = lazy(() => import("./pages/TrackingHistoric"))

export default function AppRoutes() {
	const authAccount = useAuthContext();

  return (
    <BrowserRouter>
			<Suspense fallback={<div>Loading...</div>}>
				<HeaderBar />
				<Switch>
					{authAccount.authenticated ? (
						<AuthenticatedAppRoutes /> ) : (
						<UnauthenticatedAppRoutes />
					)}
				</Switch>
				<ServiceWorkerWrapper />
			</Suspense>
    </BrowserRouter>
  );
}

const UnauthenticatedAppRoutes = () => {
  return (
    <React.Fragment>
      <Route exact path="/">
				<LandingPage />
			</Route>
			<Route path="/contactless">
				<ContactlessPage />
			</Route>
			<Route path="/importer-camera">
				<ImporterQRLoopPage />
			</Route>
			<Route path="/survey">
				<SurveyPage />
			</Route>
			<Route path="/tracking-historic">
				<TrackingHistoricPage />
			</Route>
			<Route path="/error">
				<ErrorPage />
			</Route>
    </React.Fragment>
  );
};

const AuthenticatedAppRoutes = () => {
  return (
    <React.Fragment>
			<Route exact path="/">
				<DashboardPage />
			</Route>
    </React.Fragment>
  );
};